import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './ModalLink.scss';
const ModalLink = (props)=>/*#__PURE__*/ React.createElement(BiLink, _extends({
        className: s['root']
    }, props));
ModalLink.displayName = 'ModalLink';
export default ModalLink;
